import React from 'react'
import { FirebaseAppProvider, SuspenseWithPerf } from 'reactfire'

import { firebaseConfig } from '../Firebase/FirebaseApp'
import Preference from './Preference'
import { prettyTitle } from '../../utils/utils'

const Preferences = (props) => {
  const { group, preferences, userID } = props

  return Object.keys(preferences).map((item, i) => {
    const title = prettyTitle(item)
    return (
      <FirebaseAppProvider
        key={`preferences-${group}-${item}`}
        firebaseConfig={firebaseConfig}
        initPerformance
      >
        <SuspenseWithPerf
          fallback={<p>loading preferences...</p>}
          traceId={'load-property-status'}
        >
          <Preference group={group} item={item} title={title} key={i} userID={userID} />
        </SuspenseWithPerf>
      </FirebaseAppProvider>
    )
  })
}

export default Preferences
